export const DAPP_CONFIG = {
  appName: '金狗人生',
  chainLabel: 'BSC',
  chainSubLabel: '$金狗人生',
  wallet: {
    chainId: 56,
    chainSymbol: 'BNB',
    chainErrorTip: '\u8bf7\u8fde\u63a5\u5e01\u5b89\u4e3b\u7f51\u94b1\u5305\u4f7f\u7528',
    poolAddress: '0xA2433EEe239072Fa600e6Ae054FBDB753218231F',
  },
  mint: {
    statusLabel: '预售进行中 · PRESALE LIVE',
    titleTop: '金狗人生',
    titleBottom: '预售认购',
    subtitleTop: '锁定代币 · 获得燃烧分红额度',
    subtitleBottom: '每个地址仅限一份',
    cardTitle: '认购 金狗人生',
    priceTag: '500 U / 份',
    calcLabel: '提前锁定代币',
    inviteTag: '预售专属',
    inviteHint: '认购后生成专属链接...',
    noticeTitle: '参与须知',
  },
  mining: {
    heroTitle: '参与燃烧',
    heroSubtitle: '金狗人生代币 · 燃烧分红 · BNB 收益',
    globalPriceLabel: '金狗人生 当前价格',
    mineCardTitle: '燃烧金狗人生',
    multiplierTag: '1.5x 分红额度',
    inputHint: '输入参与 BNB 金额（0.1 起）',
    inputUnit: 'BNB',
    inviteTag: '燃烧专属',
    inviteHint: '参与燃烧后生成专属链接...',
    videoCaption: '点击播放 · 金狗人生宣传视频',
  },
  socialLinks: {
    x: 'https://x.com/JGRS_cto',
    telegram: 'https://t.me/JGRS_CTO',
    debox: 'https://m.debox.pro/group?id=df4s8fkr&code=j2m8vmxc',
  },
  video: {
    src: '/video.mp4',
    poster: '',
  },
}

export const APP_TITLE = DAPP_CONFIG.appName
